import "./style.scss";
import { Link, useLocation } from "react-router-dom";
import { tabsPagesConst } from "@/src/constants/tabs-pages";
import { useEffect, useState } from "react";

function TabsPages() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>("Home");
  const [disableTab, setDisableTab] = useState<boolean>(false);

  useEffect(() => {
    const currentPathName = location.pathname.replace("/", "").replace(/^./, (c) => c.toUpperCase());
    setActiveTab(currentPathName || "Home");
    if (currentPathName !== "" && currentPathName !== "Courses" && currentPathName !== "Search" && currentPathName !== "Chat") {
      setDisableTab(true);
    } else {
      setDisableTab(false);
    }
  }, [location.pathname]);

  const handleTabClick = (text: string) => {
    setActiveTab(text);
  };

  return (
    <div className="tabs-pages">
      <div className={`tabs-pages-groups ${disableTab ? "disable" : ""}`}>
        {tabsPagesConst.tabs.map((tab, index) => (
          <Link to={tab.link} key={index} onClick={() => handleTabClick(tab.text)} className={`${activeTab === tab.text ? "active" : ""}`}>
            <tab.img />
            <p>{tab.text}</p>
          </Link>
        ))}
      </div>
      <div className="tabs-pages-navigation">
        <Link to={tabsPagesConst.navigation.link}>
          <tabsPagesConst.navigation.img />
        </Link>
      </div>
    </div>
  );
}

export default TabsPages;
